// hooks/useFormViewerWizard/step1CapiStash.ts — Stash sinyal CAPI sejak step 1.
// Order step-1 bisa closing TANPA lewat step 3 (CS proses manual) — tanpa stash,
// Meta tak pernah dengar order itu. STASH SAJA (tanpa direct-send): sweep server
// yang fire Purchase saat closing; step-3 men-stash ulang bila perlu.
import { buildThankYouPixelConfigs } from '../../../ThankYouPage/utils/pixelConfigs';
import { getStoredTtclid, getTtpCookie } from '../../../../services/attributionIds';
import { stashCapiSignals } from '../useFormViewer/capiStash';
import { getOpenAIAttribution, sourceUrl } from '../../../../services/openaiAttribution';

function getFbc(): string | undefined {
    try {
        const u = new URLSearchParams(window.location.search), f = u.get('fbclid');
        if (f) return `fb.1.${Math.floor(Date.now() / 1000)}.${f}`;
        const m = document.cookie.match(/(?:^|;\s*)_fbc=([^;]*)/);
        return m ? decodeURIComponent(m[1]) : undefined;
    } catch { return undefined; }
}

function getFbp(): string | undefined {
    try {
        const m = document.cookie.match(/(?:^|;\s*)_fbp=([^;]*)/);
        return m ? decodeURIComponent(m[1]) : undefined;
    } catch { return undefined; }
}

export function stashStep1Capi(args: { hook: any; form: any; orderId: string }): void {
    try {
        const { hook, form, orderId } = args;
        const configs = buildThankYouPixelConfigs(form, hook.globalTrackingSettings);
        const idsFor = (platform: string) =>
            (configs.find(c => c.platform === platform)?.pixelIds || []).filter((id: string) => id?.trim());
        const meta = idsFor('meta'), tiktok = idsFor('tiktok'), google = idsFor('google'), openai = idsFor('openai');
        if (!meta.length && !tiktok.length && !google.length && !openai.length) return;
        const { oppref, obref } = getOpenAIAttribution();
        stashCapiSignals({
            orderId, fbc: getFbc(), fbp: getFbp(), pageUrl: sourceUrl(),
            ttclid: getStoredTtclid(), ttp: getTtpCookie(), externalId: orderId,
            metaPixelIds: meta, tiktokPixelIds: tiktok, googlePixelIds: google, openaiPixelIds: openai, oppref, obref,
        });
    } catch { /* best-effort */ }
}
